import { render, staticRenderFns } from "./OrderPaymentsPage.vue?vue&type=template&id=33325bf1&scoped=true&"
import script from "./OrderPaymentsPage.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33325bf1",
  null
  
)

export default component.exports